function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

import { Guid as K, logger as N } from "../../shared-lib/index.js";
import { isArray as z } from "../util/code-utils.js";
import { getErrorMessage as si } from "../util/error-utils.js";

var _t = /*#__PURE__*/function () {
  function _t(t, e, i) {
    _classCallCheck(this, _t);

    this.eu = t, null == t && (t = K.ce()), !i || isNaN(i) ? this.Gl = new Date().valueOf() : this.Gl = i, this.eu = t, this.ql = new Date().valueOf(), this.kl = e;
  }

  _createClass(_t, [{
    key: "bt",
    value: function bt() {
      return "g:".concat(encodeURIComponent(this.eu), "|e:").concat(this.kl, "|c:").concat(this.Gl, "|l:").concat(this.ql);
    }
  }], [{
    key: "hE",
    value: function hE(t) {
      if ("string" != typeof t) return null;
      var e = t.lastIndexOf("|e:"),
          i = t.substring(0, e),
          r = i.split("g:")[1];
      var n;
      return n = /[|:]/.test(r) ? encodeURIComponent(r) : r, t = t.replace(i, "g:".concat(n));
    }
  }, {
    key: "Rn",
    value: function Rn(t) {
      var e;
      if ("string" == typeof t) try {
        var i = t.split("|");
        if (!z(i) || 4 !== i.length) return null;

        var r = function r(t) {
          return t.split(":")[1];
        },
            n = function n(t) {
          var e = parseInt(r(t));
          if (!isNaN(e)) return e;
        };

        e = new _t(decodeURIComponent(r(i[0])), n(i[1]), n(i[2])), e.ql = n(i[3]);
      } catch (e) {
        N.info("Unable to parse cookie string ".concat(t, ", failed with error: ").concat(si(e)));
      } else {
        if (null == t || null == t.g) return null;
        e = new _t(t.g, t.e, t.c), e.ql = t.l;
      }
      return e;
    }
  }]);

  return _t;
}();

export { _t as default };